import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DirectLoggerFactory_instance5oe6qyrhwrc1 as DirectLoggerFactory_instance } from './DirectLoggerFactory.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Level_INFO_getInstance2sl9dbxnkg9gp as Level_INFO_getInstance } from './Level.mjs';
import { DefaultMessageFormatter17x784jf2u2xo as DefaultMessageFormatter } from './Formatter.mjs';
import { ConsoleOutputAppender373h7g73cvnnw as ConsoleOutputAppender } from './ConsoleOutputAppender.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function internalCheckFactory(name, loggerFactory) {
  if (!equals(loggerFactory, DirectLoggerFactory_instance)) {
    println("kotlin-logging: [WARN] configuring 'direct." + name + "' but the active logger factory is not 'DirectLoggerFactory' (active: " + getKClassFromExpression(loggerFactory).j1() + '). This config might be ignored.');
  }
}
var KotlinLoggingConfiguration$direct$1Class;
function KotlinLoggingConfiguration$direct$1() {
  if (KotlinLoggingConfiguration$direct$1Class === VOID) {
    class $ {
      constructor() {
        this.i2h_1 = Level_INFO_getInstance();
        this.j2h_1 = new (DefaultMessageFormatter())(true);
        this.k2h_1 = new (ConsoleOutputAppender())();
      }
      l2h(value) {
        this.i2h_1 = value;
        internalCheckFactory('logLevel', KotlinLoggingConfiguration_getInstance().y2f_1);
      }
      d2h() {
        return this.i2h_1;
      }
      m2h(value) {
        this.j2h_1 = value;
        internalCheckFactory('formatter', KotlinLoggingConfiguration_getInstance().y2f_1);
      }
      z2f() {
        return this.j2h_1;
      }
      f2h() {
        return this.k2h_1;
      }
    }
    initMetadataForClass($);
    KotlinLoggingConfiguration$direct$1Class = $;
  }
  return KotlinLoggingConfiguration$direct$1Class;
}
var KotlinLoggingConfigurationClass;
function KotlinLoggingConfiguration() {
  if (KotlinLoggingConfigurationClass === VOID) {
    class $ {
      constructor() {
        KotlinLoggingConfiguration_instance = this;
        this.w2f_1 = true;
        var tmp = this;
        tmp.x2f_1 = new (KotlinLoggingConfiguration$direct$1())();
        this.y2f_1 = DirectLoggerFactory_instance;
      }
    }
    initMetadataForObject($, 'KotlinLoggingConfiguration');
    KotlinLoggingConfigurationClass = $;
  }
  return KotlinLoggingConfigurationClass;
}
var KotlinLoggingConfiguration_instance;
function KotlinLoggingConfiguration_getInstance() {
  if (KotlinLoggingConfiguration_instance === VOID)
    new (KotlinLoggingConfiguration())();
  return KotlinLoggingConfiguration_instance;
}
//region block: exports
export {
  KotlinLoggingConfiguration_getInstance as KotlinLoggingConfiguration_getInstance1qkm2mkxywgav,
};
//endregion

//# sourceMappingURL=KotlinLoggingConfiguration.mjs.map
